// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"454":"c36a832f","624":"bce8108d","845":"e3bc50e7"}[chunkId] + ".css";
};